// ----------------------------------------------------------------------
export const Snackbar = () => {
    return {
        MuiSnackbarContent: {
            styleOverrides: {
                root: {}
            }
        }
    };
};
//# sourceMappingURL=Snackbar.js.map